class SubCategoryComponent extends HTMLElement {
  constructor(){
    super();
    this.subCategoryTitles = [...this.querySelectorAll('[data-subcategory-title]')];
    this.collections = this.getCollectionData() || [];
    this.connectedCallback();
  }

  getCollectionData(){
    var that = this;
    return this.subCategoryTitles.map(subCategoryTitle => {
      console.log(subCategoryTitle.dataset)
      const url = subCategoryTitle.getAttribute('href');
      const id = subCategoryTitle.dataset.collectionId;
      const filter =subCategoryTitle.dataset.subcategoryFilter;
      return ({
        id,
        filter,
        url: that.buildUrl({id, filter})
      })
    });
  }
  buildUrl({id, filter}){
    return `https://services.mybcapps.com/bc-sf-filter/filter?${filter}&t=1704011637716&_=pf&shop=proof-living-singapore.myshopify.com&page=1&limit=20&sort=best-selling&display=grid&collection_scope=${id}&tag=&product_available=false&variant_available=false&build_filter_tree=true&check_cache=false&locale=en&sid=aecca6e4-293c-45da-894c-5fb1ada773de&callback=&event_type=init`
  }
  // connectedCallback= () => {
  //   Promise.all(this.collections.map(collection => this.fetchSubcategoryCount(collection.url, collection.id))).then(responses => {
  //     responses.forEach((response, index) => {
  //       if(!response) {
  //         return;
  //       }
  //       console.log(response)
  //       const {total_product, id} = response;
  //       const subCategoryTitle = this.subCategoryTitles.find(subCategoryTitle => subCategoryTitle.dataset.collectionId === id);
  //       if(subCategoryTitle) {
  //         subCategoryTitle.querySelector('[data-subcategory-count]').textContent = `${total_product}`;
  //       }

  //     })
  //   }).catch(error => console.log(error));
  // }

  async fetchSubcategoryCount(url, id){
    return fetch(url)
    .then(response => response.json())
    .then(data => ({...data, id}));
  }
}
customElements.define('subcategory-component', SubCategoryComponent);